module.exports = __webpack_public_path__ + "static/introduction_img4@2x-43f8d5eda7b98133faabb3a2f4f7c603.jpg";